import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
// 1..12 — the hour dropdown's domain. Twelve options is fast to scan.
const HOURS = Array.from({ length: 12 }, (_, i) => i + 1);
// Four quarter-hour options.
const MINUTES = ["00", "15", "30", "45"];
// Snap an incoming minute to the nearest 15-min boundary (floor). Mirrors
// TimeSelect's normalize() so legacy data like "09:07" still maps onto
// one of our four options instead of leaving the dropdown blank.
function snapMinute(m) {
    const snapped = Math.floor(m / 15) * 15;
    return String(snapped).padStart(2, "0");
}
// Split "HH:MM[:SS]" into the three parts. Anything malformed falls back
// to 9:00 AM — sensible default for a brand-new block.
function split(value) {
    const parts = (value || "").split(":");
    const h24 = Math.max(0, Math.min(23, Number(parts[0] ?? "9") || 0));
    const m = Math.max(0, Math.min(59, Number(parts[1] ?? "0") || 0));
    const ap = h24 < 12 ? "AM" : "PM";
    const h12 = h24 === 0 ? 12 : h24 > 12 ? h24 - 12 : h24;
    return { h12: String(h12), m: snapMinute(m), ap };
}
// Inverse of split() — build "HH:MM" (24-hour) from the three pickers.
function join(h12, m, ap) {
    const h = Number(h12) || 12;
    let h24;
    if (ap === "AM") {
        h24 = h === 12 ? 0 : h;
    }
    else {
        h24 = h === 12 ? 12 : h + 12;
    }
    return `${String(h24).padStart(2, "0")}:${m}`;
}
export default function HourAmPmSelect({ value, onChange, disabled }) {
    const { h12, m, ap } = split(value);
    return (_jsxs("span", { className: "hour-ampm-select", children: [_jsx("select", { value: h12, disabled: disabled, onChange: (e) => onChange(join(e.target.value, m, ap)), "aria-label": "Hour", children: HOURS.map((h) => (_jsx("option", { value: h, children: h }, h))) }), _jsx("span", { className: "hour-ampm-sep", children: ":" }), _jsx("select", { value: m, disabled: disabled, onChange: (e) => onChange(join(h12, e.target.value, ap)), "aria-label": "Minute", children: MINUTES.map((mm) => (_jsx("option", { value: mm, children: mm }, mm))) }), _jsxs("select", { value: ap, disabled: disabled, onChange: (e) => onChange(join(h12, m, e.target.value)), "aria-label": "AM or PM", children: [_jsx("option", { value: "AM", children: "AM" }), _jsx("option", { value: "PM", children: "PM" })] })] }));
}
